
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "Inadimplencia",
  components: { FiltroPeriodo },
  props: {
    // valores vindos do back
    inadimplencia: {}, // ex.: 45000.12

    // período atual (opcional): { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' } ou null
    periodo: { type: Object, default: null },

    // estado de carregamento
    loading: { type: Boolean, default: false },

    // não emitir @apply no boot (mantém silencioso no F5)
    ignoreInitialApply: { type: Boolean, default: true },
  },

  computed: {
    valorTotalNumber() {
      const n = Number(String(this.inadimplencia.valor).replace(",", "."));
      return Number.isFinite(n) ? n : 0;
    },
    percentualNumber() {
      const n = Number(String(this.inadimplencia.percentual).replace(",", "."));
      return Number.isFinite(n) ? n : 0;
    },
    percentualBadgeClass() {
      // > 10% danger, senão warning
      return this.percentualNumber > 10 ? "badge-danger" : "badge-warning";
    },
  },

  methods: {
    onApplyPeriodo({ inicio, fim }) {
      this.$emit("change-periodo", { inicio, fim });
    },
    toCurrency(value) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(value ?? 0);
      } catch {
        const num = Number(value ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },
    // Simples: troca ponto por vírgula e acrescenta '%'
    formatPercent(v) {
      if (v === null || v === undefined || v === "") return "0%";
      return `${String(v).replace(".", ",")}%`;
    },
  },
};
